export const ajax = {
  async get(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');

      const text = await response.text(); // まずは生のレスポンスを取得
      // console.log('--- RAW RESPONSE ---\n', text); // デバッグ用に出力

      let data;
      try {
        data = JSON.parse(text); // パースを明示的に try-catch
      } catch (e) {
        console.error('JSON parse error. Raw response:', text);
        throw new Error('サーバーからのレスポンスが正しいJSONではありません');
      }

      return data;
    } catch (error) {
      console.error('GET Error:', error);
      throw error; // 呼び出し元で catch させる
    }
  },

  async post(url, payload) {
    try {
      const formBody = new URLSearchParams(payload).toString();

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formBody,
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error('JSON parse error. Raw response:', text);
        throw new Error('サーバーからのレスポンスが正しいJSONではありません');
      }

      return data;
    } catch (error) {
      console.error('POST Error:', error);
      throw error;
    }
  },
};
